import { formatFerveDate } from "@utils/date-format"
import { FerveCartItem } from "./ferve-cart"
import { useFindSession } from "@features/program/useProgramData"
import { useMemo } from "react"

export function useResolvedCartSession(item: FerveCartItem) {
  const ferveDate = useMemo(() => item.dateTime && formatFerveDate(item.dateTime), [item.dateTime])
  const result = useFindSession(
    (session, film) => {
      return item.title === film.title && session.info?.dateTime === ferveDate
    },
    [item.title, ferveDate],
  )

  return {
    film: result?.film,
    session: result?.session,
  }
}
